import { css } from '@emotion/react'
import { themeColorPropOr } from '@groovehq/internal-design-system/lib/util/theme'

const primary = theme => css`
  &.active {
    color: ${theme.color.primary.brand};
  }

  &:hover {
    color: ${theme.color.brand['700']};
  }

  &:active {
    color: ${theme.color.brand['900']};
  }
`

const note = theme => css`
  &.active {
    color: ${theme.color.primary.warningText};
  }

  &:hover {
    color: ${theme.color.primary.warning};
  }

  &:active {
    color: ${theme.color.warning['700']};
  }
`

const types = {
  primary,
  note,
}

const base = props => css`
  height: 100%;
  color: ${props.theme.color.monochrome.mediumDark};
  cursor: pointer;
  font-size: 13px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 1px;
  line-height: 24px;
  transition: color 0.2s;

  &.active {
    color: ${themeColorPropOr('color.primary.brand')(props)};
  }

  ${types[props.type] && types[props.type](props.theme)};
`

export const styles = {
  base,
}
